import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
    state() {
      return {
        orderList: [],
        orderDefAddress: {},
        mtDefAccount: {}
      }
    },
    mutations: {
      setOrderList (state, payload) {
        state.orderList = payload;
      },
      setOrderDefAddress (state, payload) {
        state.orderDefAddress = payload;
      },
      setMtDefAccount (state, payload) {
        state.mtDefAccount = payload;
      }
    },
    actions: {
      updateOrderList ({ commit }, payload) {
        commit('setOrderList', payload);
      },
      updateOrderDefAddress ({ commit }, payload) {
        commit('setOrderDefAddress', payload);
      },
      updateMtDefAccount ({ commit }, payload) {
        commit('setMtDefAccount', payload);
      }
    },
})
export default store;